export const StatusPlain = {
    Ing: {
        key: 1,
        status: 'ing',
        value: '未审核'
    },
    Pass: {
        key: 2,
        status: 'pass',
        value: '已通过'
    },
    Fail: {
        key: 3,
        status: 'fail',
        value: '不通过'
    }
}

export const StatusMap = new Map([
    [StatusPlain.Ing.key, StatusPlain.Ing],
    [StatusPlain.Pass.key, StatusPlain.Pass],
    [StatusPlain.Fail.key, StatusPlain.Fail]
])
